module.exports = __webpack_public_path__ + "media/images/pc/special_reports/icon_bouquet-16a31758c96aaff10789780199e0c9aa.png";